import CryptoJS from "crypto-js";

export function addCryptography(name, data, password) {
  const dataEncrypted = CryptoJS.AES.encrypt(data, password);
  localStorage.setItem(name, dataEncrypted);
}

export function addCryptographyGuard(data, password) {
  return CryptoJS.AES.encrypt(data, password);
}

export function removeCryptography(name, password) {
  if (localStorage.getItem(name) !== null) {
    const encryptedData = localStorage.getItem(name);
    const decryptingData = CryptoJS.AES.decrypt(encryptedData, password);
    const decryptedData = JSON.parse(
      decryptingData.toString(CryptoJS.enc.Utf8)
    );

    return decryptedData;
  }
}

export function removeCryptographyGuard(name, password) {
  return CryptoJS.AES.decrypt(name, password);
}
